import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import {SvgModule} from "../svg";
import {TranslatedStringModule} from "../translated-string";
import {AutoWidthModule} from "../auto-width-directive";
import { CustomAttributeListValuePickerComponent } from './custom-attribute-list-value-picker.component';

@NgModule({
  declarations: [CustomAttributeListValuePickerComponent],
  imports: [CommonModule, FormsModule, NgSelectModule, SvgModule, TranslatedStringModule, AutoWidthModule],
  exports: [CustomAttributeListValuePickerComponent]
})
export class CustomAttributeListValuePickerModule {}

export * from './custom-attribute-list-value-picker.component';
export * from './model';